module.exports = __webpack_public_path__ + "img/tyro-logo-bw.1f337b15.png";